jQuery(document).ready(function($) {

	// *************************************************************************************************
	//	Homepage
	// *************************************************************************************************

	if (document.body.classList.contains('home')) {
		// **************************************************
		//	Model Row
		// **************************************************

		if ($('.modelRow .swiper-container').length) {
			var models_slider = new Swiper('.modelRow .swiper-container', {
				speed: 300,
				slidesPerGroup: 6,
				slidesPerView: 6,
				spaceBetween: 40,
				watchOverflow: true,
				lazy: {
					enabled: true,
				},
				navigation: {
					nextEl: '.modelRow .swiper-button-next.model',
					prevEl: '.modelRow .swiper-button-prev.model'
				},
				breakpoints: {
					1399: {
						slidesPerGroup: 5,
						slidesPerView: 5
					},
					1199: {
						slidesPerGroup: 4,
						slidesPerView: 4
					},
					979: {
						slidesPerGroup: 3,
						slidesPerView: 3
					},
					767: {
						slidesPerGroup: 1,
						slidesPerView: 1
					},
				},
			});
	
			$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
				var index = $(this).parent().index()
				if (models_slider && models_slider[index]) {
					models_slider[index].update();
					models_slider[index].navigation.update();
				}
				if (typeof LazyLoad === "function") {
					var myLazyLoad = new LazyLoad();
				}
			})
	
			if ($(window).width() <= 1024) {
				jQuery('#small-selects #modelTab-contents li a').click(function() {
					var title = jQuery(this).data('title');
					jQuery('#modelTab .swap').html(title);
				});
			}
	
			// Lazyload
			setTimeout(function() {
				$(".modelRow .vehicle-box__image img").each(function() {
					$(this).attr("src", $(this).attr("data-original"));
				});
			}, 3000);
		}

		// **************************************************
		//	Reviews Row
		// **************************************************

		if ($('.reviewsRow .swiper-container').length) {
			var reviews = new Swiper('.reviewsRow .swiper-container', {
				speed: 300,
				slidesPerGroup: 3,
				slidesPerView: 3,
				spaceBetween: 40,
				watchOverflow: true,
				lazy: {
					enabled: true,
				},
				navigation : {
					nextEl : '.reviewsRow .swiper-button-next.reviews',
					prevEl : '.reviewsRow .swiper-button-prev.reviews'
				},
				breakpoints: {
					1024: {
						slidesPerGroup: 2,
						slidesPerView: 2
					},
					767: {
						slidesPerGroup: 1,
						slidesPerView: 1
					},
				},
			});
		}

		// **************************************************
		//	Featured and Collectible Rows
		// **************************************************

		if ($('.featuredRow .swiper-container').length) {
			var collectible_slider = new Swiper('.featuredRow .swiper-container', {
				speed: 300,
				spaceBetween: 40,
				watchOverflow: true,
				navigation : {
					nextEl : '.featuredRow .swiper-button-next',
					prevEl : '.featuredRow .swiper-button-prev'
				},
				slidesPerGroup: 3,
				slidesPerView: 3,
				breakpoints: {
					1024: {
						slidesPerGroup: 3,
						slidesPerView: 3
					},
					767: {
						slidesPerGroup: 1,
						slidesPerView: 1
					},
				},
				preloadImages: false,
	
				// Enable lazy loading
				lazy: true
			});
	
			// Lazyload
			setTimeout(function() {
				$(".featuredRow img").each(function() {
					$(this).attr("src", $(this).attr("data-original"));
				});
			}, 3000);
		}

		// **************************************************
		//	Scroll Reveal
		// **************************************************

		$(window).bind("load", function() {
			//grab all elements that have the .ux-loading-item class
			var uxElements = $('.ux-loading-item');
			
			//run through the uxElements object array
			if (uxElements) { //run through the uxElements object array
				uxElements.each(function(index) {
			
					//make instances of each one - this
					var Element = $(this);
				
					//run a time out and add class of active and multiply the delay times the position it is in the object
					setTimeout(function() {
						Element.addClass('active');
					}, 400 * index);
				});
			}
		});
			
		var sr_elements = $('.fly-in-bottom, .fly-in-left, .fly-in-right, .fly-in-top');
			
		// if there are sr elements let's do them
		if (sr_elements) {
			window.sr = ScrollReveal({
				duration: 250,
				scale: 1,
				origin: 'bottom',
				distance: '100px',
				easing: 'ease'
			});
			
			sr.reveal('.fly-in-left', {
				origin: 'left'
			});
			
			sr.reveal('.fly-in-right', {
				origin: 'right'
			});
			
			sr.reveal('.fly-in-bottom', {
				origin: 'bottom'
			});
			
			sr.reveal('.fly-in-top', {
				origin: 'top'
			});
			
			// Add classes of sections that will be revealed when you scroll to them
			// sr.reveal('.buttonRow .buttonWrapper', 75);
			// sr.reveal('.modelRow .wrapperRow', 75);
			// sr.reveal('.reviewsRow > div', 75);
			// sr.reveal('.featuredRow > div', 75);
			// sr.reveal('.collectibleRow > div', 75);
			// sr.reveal('.ctaRow .cta__container', 75);
			// sr.reveal('.rewardsRow .rewardsRow__container', 75);
			// sr.reveal('.instagramRow .instagramWrapper__feed', 75);
			// sr.reveal('.mapRow .mapWrapper__directions', 75);
			// sr.reveal('.seoRow > div', 75);
		}
		
	}
	
	// *************************************************************************************************
	//	Footer
	// *************************************************************************************************

	// Mobile Footer Menus
	if ($(window).width() <= 767) {
		$('.linkWrapper__widgets .widget').on('click', function() {
			$(this).toggleClass('active').siblings().removeClass('active');
			$(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
		});
	}

	// *************************************************************************************************
	//	Vehicle Results Page (VRP)
	// *************************************************************************************************

	if (document.body.classList.contains('page-vehicle-results-page') || document.body.classList.contains('page-template-page-lightning')) {
		// Remove "Sort by: Relevance"
		vrp_remove_sort_by_relevance = function(){
			var resultPage = document.getElementById('results-page');
			var sortOptions = resultPage.querySelector('.results .sorting-options select[name="_orderby"]');
			if(sortOptions){
				sortOptions.remove('');
			}
		}
		jQuery(function(){
			vrp_remove_sort_by_relevance();
			jQuery("body").on("vrp-ajax-complete",function(){
				vrp_remove_sort_by_relevance();
			});
		});
	}

});
